import { render, staticRenderFns } from "./participantSettingHead.vue?vue&type=template&id=c33d4258&scoped=true"
import script from "./participantSettingHead.vue?vue&type=script&lang=js"
export * from "./participantSettingHead.vue?vue&type=script&lang=js"
import style0 from "./participantSettingHead.vue?vue&type=style&index=0&id=c33d4258&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33d4258",
  null
  
)

export default component.exports